import { node, shape, string } from "prop-types";

import classify from "web/classify";

import defaultClasses from "./transparentButton.scss";

const TransparentButton = ({ children, classes, type, ...rest }) => {
  return (
    // eslint-disable-next-line
    <button className={classes.root} type={type} {...rest}>
      {children}
    </button>
  );
};

TransparentButton.propTypes = {
  children: node,
  classes: shape({
    root: string,
  }).isRequired,
  type: string,
};

TransparentButton.defaultProps = {
  children: null,
  type: "button",
};

export default classify(defaultClasses)(TransparentButton);
